import React, { Component } from 'react';
import {connect} from 'react-redux';
import { refArchSession, refArchBOM } from '../State/actions/sessions';
import Box from 'grommet/components/Box';
import Heading from 'grommet/components/Heading';
import Paragraph from 'grommet/components/Paragraph';
import Anchor from 'grommet/components/Anchor';
import CloseIcon from 'grommet/components/icons/base/FormClose';
import Table from 'grommet/components/Table';
import TableRow from 'grommet/components/TableRow';
import Layer from 'grommet/components/Layer';

//function CreateGuid() {  
//   function _p8(s) {  
//      var p = (Math.random().toString(16)+"000000000").substr(2,8);  
//      return s ? "-" + p.substr(0,4) + "-" + p.substr(4,4) : p ;  
//   }  
//   return _p8().toUpperCase() + _p8().toUpperCase() + _p8().toUpperCase() + _p8().toUpperCase();  
//}

class AdditionalReferenceComponent extends Component {
   
   constructor(props){
      super(props);
      this.state = { 
                     WhatsnewJson: '',                    
                   };
      this.closePopUps=this.closePopUps.bind(this);  
      this.callRAContent = this.callRAContent.bind(this);
   }

   closePopUps(e){
        this.props.click();
   }

   componentWillReceiveProps(nextProps){
      // RABOM

      if(nextProps.activeSession.id!="") {      
        if(nextProps.activeSession.id !== this.props.activeSession.id){
          if(nextProps.activeSession.treeView !== ''){
            var obj = "";
            obj = nextProps.activeSession.workload;            
            this.props.onNewSession(obj);
            this.props.redirectTo('/Build/SolnAlternative');
            // this.props.history.push('/Build/SolnAlternative');
          }else{
            // var obj ="";              
            // obj = nextProps.activeSession.workload;                
            // this.props.onNewSession(obj);          
            // this.props.redirectTo(interviewScreens[0].path);
            // this.props.history.push('/Build/ContactInfo');
          }    
        }

        if(nextProps.referenceArchitectBOM !== this.props.referenceArchitectBOM){
          // nextProps.referenceArchitectBOM
          var newWindow = window.open();
          newWindow.document.write(nextProps.referenceArchitectBOM);
        }
      }
   }

   callRAContent(obj){
        this.props.onRAClick( obj );
   }

   render() {
      let RefArchList;

     if( this.props.referenceArchitect !== undefined && this.props.referenceArchitect !== '' ){
      RefArchList = this.props.referenceArchitect.Doc.map( (val,id) => {    
          return(
                 <TableRow key={id.toString()}>
                            <td className='secondary'> <Anchor style ={{cursor:'pointer'}} onClick={() => window.open(decodeURIComponent(val["Url"]))}  > {val["Name"]} </Anchor> </td>
                           {/*<td className='secondary'> <Anchor href={val["Url"]} target="_blank" > {val["Name"]} </Anchor> </td>*/}
                           <td className='secondary'> <Anchor primary={true} onClick={ () => { this.props.onRAClick({"UserId":"Madhukar", "Architecture": val["Name"], "Option": "Solution",  }) } } > Customize this RA Solution </Anchor> </td>
                           <td className='secondary'> <Anchor primary={true} onClick={ () => { this.props.onRAClick({"UserId":"Madhukar", "Architecture": val["Name"], "Option": "BOM",  }) } } target="_blank"> BOM (Bill of Material) </Anchor> </td>
                 </TableRow>
          );
      } );
     }

    let content = '';
    if( this.props.referenceArchitect !== undefined && this.props.referenceArchitect !== '' ){
      content =  <Layer className="ReferececeArchitcture" style={{width:'50%',height:'50%'}}>
                                <Box direction="column" margin="none" pad="none">
                                    <Box direction="row" colorIndex="neutral-1" margin="none" pad="small" separator="bottom">
                                          <Box direction="row" margin="none" pad="none" align='start' style={{width:'96%'}}>
                                               <Heading tag="h4"strong={true} style={{marginBottom:'0px',color:'#01a982'}}>Reference Architecture</Heading>
                                          </Box>
                                          <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.closePopUps} >
                                               <CloseIcon colorIndex="light-2" className="CloseIconStyle" />
                                          </Box>
                                    </Box>
                                    <Box margin="none" pad="small">
                                            <Heading tag="h6" strong={true} style={{margin:'4px 0px'}}>Learn More</Heading>
                                            <Paragraph style={{margin:'2px 0px', maxWidth:'100%'}}>{this.props.referenceArchitect["@Text"]}</Paragraph>
                                            <Table style={{margin:'4px 0px', overflow:'initial'}} selectable={false}>
                                                <tbody>
                                                  {RefArchList}
                                                </tbody>
                                            </Table>
                                    </Box>
                                </Box>
                               </Layer>
        
    }else{
        content = '';
    }
    return (
        <Box margin="none" pad="none">{ content }   </Box>
    );

   }
}

const mapStateToProps = (state) => {  
   return{
      activeSession: state.sessions.activeSession,
      DefaultInputs: state.sessions.sessionDefaults.inputs.Sizers.Sizer,
      referenceArchitect: state.sessions.sessionDefaults.inputs.Sizers.Sizer.ReferenceArchitecture,
      referenceArchitectBOM: state.sessions.RABOM
   };
};

const mapDispatchToProps = (dispatch) => {
  return {
      onRAClick : (data) => {
          if( data["Option"] === "BOM" ) {
            dispatch( refArchBOM (data) );
          }else if( data["Option"] === "Solution" ) {
            dispatch( refArchSession(data) );
          }
      },
      
      onNewSession:(workload) => {
        dispatch({ type:'UPDATE_SIZER_WORKLOAD', payload: workload })
      },

  };
};

export default connect(mapStateToProps,mapDispatchToProps)(AdditionalReferenceComponent);



// WEBPACK FOOTER //
// ./src/SizerHome/ReferenceArchitecture.js